module.exports = __webpack_public_path__ + "static/media/landing.0dbeecdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/home/landing/landing.jpg
// module id = 865
// module chunks = 0